import { useRouter } from "next/router";
import { useEffect } from "react";
import { eventNames } from "services/mixpanel/events";
import trackEvent from "services/mixpanel/mixpanel";
import { useAuth } from "stores/auth/auth-context";
import { createSuperPropertiesForTrackingEvent } from "utils/mixpanel/mixpanel-utils";
import { isObjectEmpty } from "utils/utils";
import { IUseSelectRole } from "./use-select-role.type";

const useSelectRole = (): IUseSelectRole => {
  const router = useRouter();
  const routerPath = router.pathname;
  const { user } = useAuth();
  const { userData } = user;

  useEffect(() => {
    trackEvent({
      eventName: eventNames.roleSelectionScreenViewed,
      payload: {
        ...createSuperPropertiesForTrackingEvent({ useAuthData: user })
      }
    });

    if (!isObjectEmpty(userData.primary_user)) {
      router.push({
        pathname: "/"
      });
    }
  }, []);

  return {
    routerPath
  };
};

export { useSelectRole };
